// IP 合作谈判「回复」操作列抽象组件（可复用：核心商务条款 / IP合作游戏方详情 / 权益等）。
// 编辑态：三个 Tag（接受/修改/拒绝）并排，非选中 light-grey，选中彩色（接受绿/修改橙/拒绝红）；
// 只读态：仅展示选中的 Tag（彩色），无选中值显示 "--"。

import React from 'react';
import { Space, Tag } from '@bedrock/components';

// 操作中文映射（NegotiationItem.action）
export const ACTION_TEXT_MAP: Record<string, string> = {
  ACCEPT: '接受',
  MODIFY: '修改',
  REJECT: '拒绝',
};

// 操作选项（编辑态三 Tag）
export const ACTION_OPTIONS = [
  { name: '接受', value: 'ACCEPT' },
  { name: '修改', value: 'MODIFY' },
  { name: '拒绝', value: 'REJECT' },
];

// Tag 颜色：非选中 light-grey；选中 ACCEPT=light-green / MODIFY=light-orange / REJECT=light-red
export const ACTION_TAG_COLOR: Record<
  string,
  'light-grey' | 'light-green' | 'light-orange' | 'light-red'
> = {
  ACCEPT: 'light-green',
  MODIFY: 'light-orange',
  REJECT: 'light-red',
};

interface ActionTagCellProps {
  /** 当前操作 ACCEPT/MODIFY/REJECT */
  value?: string;
  /** 选择操作回调（编辑态点击 Tag 触发） */
  onChange?: (action: string) => void;
  /** 编辑态：三 Tag 可选择；只读态：仅展示选中 Tag */
  editable?: boolean;
}

const ActionTagCell: React.FC<ActionTagCellProps> = ({ value, onChange, editable = false }) => {
  // 只读态：仅展示选中的 Tag，无选中值显示 --
  if (!editable) {
    if (!value) return <span className="text-color-3">--</span>;
    return (
      <Tag
        size="medium"
        text={ACTION_TEXT_MAP[value] || value}
        color={ACTION_TAG_COLOR[value] || 'light-grey'}
      />
    );
  }
  // 编辑态：三个 Tag 并排可点击
  // 走查：回复操作 Tag 用 Medium + 间距 2px（外包 UX 要求），回复列编辑态 180px 保证三个 Tag 单行
  return (
    <Space size={2}>
      {ACTION_OPTIONS.map((opt) => (
        <span key={opt.value} className="cursor-pointer" onClick={() => onChange?.(opt.value)}>
          <Tag
            size="medium"
            text={opt.name}
            color={value === opt.value ? ACTION_TAG_COLOR[opt.value] : 'light-grey'}
          />
        </span>
      ))}
    </Space>
  );
};

export default ActionTagCell;
